//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import { FormInput } from '@/components/Form'
import { rutFilter } from 'vue-dni'
import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar'
import Button from '~/components/Shared/Button'

export default {
  name: 'ModalEditUser',
  components: {
    Button,
    ModalWithTitleBar,
    ValidationObserver,
    FormInput,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      required: true,
    },
    requiredFields: {
      type: Array,
      default: () => ['name', 'email'],
    },
  },
  data() {
    return {
      active: this.value,
      form: {
        situationLaboral: '',
        occupation: '',
        user: {
          id: 0,
          names: '',
          lastnames: '',
          email: '',
          repeatEmail: '',
          identification_number: '',
          phone: '',
        },
        message: null,
      },
      isValidForm: false,
    }
  },
  watch: {
    value() {
      this.active = this.value
    },
    user() {
      this.form.user.id = this.user.id
      this.form.user.names = this.user.names
      this.form.user.lastnames = this.user.lastnames
      this.form.user.email = this.user.email
      this.form.user.repeatEmail = this.user.email
      this.form.user.identification_number = this.user.identification_number
      this.form.user.phone = this.user.phone
    },
    form: {
      handler(val) {
        this.form.user.identification_number = rutFilter(
          this.form.user.identification_number
        )
        this.checkValid()
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    async checkValid() {
      if (!this.$refs.editUserFormObserver) {
        this.isValidForm = false
        return
      }
      this.isValidForm = await this.$refs.editUserFormObserver.validate()
    },
    close() {
      this.active = !this.active
      this.cleanForm()
      this.$emit('close')
      this.$emit('input', this.active)
    },
    editUser() {
      this.$emit('edit-user', {
        ...this.form.user,
        username: this.form.user.email,
      })
    },
    cleanForm() {
      this.form.user.id = this.user.id
      this.form.user.names = this.user.names
      this.form.user.lastnames = this.user.lastnames
      this.form.user.email = this.user.email
      this.form.user.repeatEmail = this.user.email
      this.form.user.identification_number = this.user.identification_number
      this.form.user.phone = this.user.phone
    },
    formatRules(field, defaultRules) {
      const isRequired = this.requiredFields.includes(field)
      if (!defaultRules) {
        return isRequired ? 'required' : ''
      }
      return isRequired ? `${defaultRules}|required` : defaultRules
    },
  },
}
